import { render } from "./NewConfigurationStepCreateForm.vue?vue&type=template&id=35654496"
import script from "./NewConfigurationStepCreateForm.vue?vue&type=script&lang=js"
export * from "./NewConfigurationStepCreateForm.vue?vue&type=script&lang=js"

import "./NewConfigurationStepCreateForm.vue?vue&type=style&index=0&id=35654496&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
